import React, { useRef, useEffect, useState } from 'react';

type Props = {
  children?: React.ReactNode;
  once?: boolean;
};

const InView = ({ children, once }: Props) => {
  // Refs
  const ref = useRef(null);
  const observerRef = useRef(null);

  // States
  const [isInView, setIsInView] = useState(false);
  const [isIntersectedOnce, setIsIntersectedOnce] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const callback = (entries) => {
      const [entry] = entries;
      const isIntersecting = entry.isIntersecting;

      setIsInView(isIntersecting);

      if (once && observerRef.current && isIntersecting) {
        observerRef.current.disconnect();
      }
    };

    const observer = new IntersectionObserver(callback, { root: null, rootMargin: '0px', threshold: 0 });
    observer.observe(ref.current);
    observerRef.current = observer;

    return () => {
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [ref]);

  useEffect(() => {
    setIsIntersectedOnce(once && isInView);
  }, [isInView]);

  return <>{children(ref, isInView, isIntersectedOnce)}</>;
};

export default InView;
